import { useBlockDraftGate } from '../BlockDraftContext'

/**
 * E7/E8/E9: общий предикат — у ОТКРЫТОГО (выделенного) блока есть
 * несохранённая правка.
 *
 * Черновик — один инстанс на редактор (`BlockDraftProvider` в `EditorShell`),
 * поэтому его `isDirty` видит правку автора, даже если она случилась до
 * запуска прогона. Прогон переписал бы блок на сервере, а расхождение
 * черновика с новым снимком (Task 7) заставило бы панель посчитать его
 * «настоящей правкой автора» — клик по «Сохранить» стёр бы оплаченный
 * результат. Гасим старт ДО него, а не разруливаем конфликт после.
 *
 * Единственный вход в `draft.isDirty` для обеих точек старта — композер
 * правки (`useHasUnsavedBlockInScope`, точная область) и диалог отрисовки
 * картинок (E9, напрямую): вторую копию условия заводить нельзя.
 */
export const useHasUnsavedBlockDraft = (): boolean => {
  const gate = useBlockDraftGate()
  return gate.isDirty && gate.blockId !== null
}

/**
 * E8: частный случай общего предиката — область правки известна клиенту
 * (`useEditScope().blockIds`), поэтому старт гасится, только если грязный
 * блок реально входит в неё. У отрисовки картинок (E9) область считает
 * СЕРВЕР (`auto_targets` сметы) — пересечь её с грязным блоком нельзя,
 * поэтому там используется общий предикат выше без сужения по id.
 */
export const useHasUnsavedBlockInScope = (blockIds: number[]): boolean => {
  const gate = useBlockDraftGate()
  const hasUnsavedDraft = useHasUnsavedBlockDraft()
  return hasUnsavedDraft && gate.blockId !== null && blockIds.includes(gate.blockId)
}
